<ng-container *ngrxLet="isSharedCase$ as isSharedCase">
    <div class="top-bar flex-row">
        <div class="flex-row">
            <button
                class="button-transparent flex-row"
                (click)="isSharedCase ? goToInfoPage() : showCaseManagement()"
            >
                <img
                    class="logo"
                    src="../../assets/images/ariadne-spatial-logo.png"
                    alt="ariadne_logo"
                />
            </button>
            <cds-button
                size="sm"
                action="flat"
                [disabled]="isSharedCase"
                (click)="showCaseManagement()"
                >Datasets</cds-button
            >
            <ng-container *ngIf="hasCaseId$ | async">
                <cds-button
                    size="sm"
                    action="flat"
                    [disabled]="isSharedCase"
                    (click)="showJobStatus()"
                    >Jobs</cds-button
                >
            </ng-container>
        </div>

        <ng-container *ngIf="showViewerControls">
            <div class="flex-row viewer-controls">
                <ng-container *ngIf="viewer.position$ | async as pos">
                    <app-viewer-coordinate-controls
                        [position]="pos"
                        (setPosition)="viewer.setPosition($event)"
                        (centerPosition)="viewer.centerPosition()"
                    ></app-viewer-coordinate-controls>
                </ng-container>
                <ng-container *ngIf="viewer.zoom$ | async as zoom">
                    <app-viewer-zoom-controls
                        [zoom]="zoom"
                        (zoomChange)="viewer.setZoom($event)"
                    ></app-viewer-zoom-controls>
                </ng-container>
            </div>
        </ng-container>

        <div class="flex-row">
            <button class="icon-button" (click)="startSnapshot()">
                <img
                    class="snapshot-icon"
                    src="../../../../assets/icons/snapshot.svg"
                    alt="Download snapshot"
                />
            </button>
            <span class="username">{{ userName$ | async }}</span>
            <app-logout [isSharedCase]="isSharedCase"></app-logout>
        </div>
    </div>
    <div class="canvas" [ngStyle]="{ visibility: snapshotMode ? 'visible' : 'hidden' }">
        <app-snapshot-canvas [switchSnapshotMode]="switchSnapshotMode"></app-snapshot-canvas>
    </div>
</ng-container>
